import React from "react";

const IArrow = ({ color = "#D8D8D9", width = "13", height = "12", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      {...props}
    >
      <path
        d="M10.875 5.5C11.1511 5.5 11.375 5.72386 11.375 6C11.375 6.27614 11.1511 6.5 10.875 6.5H2.125C1.84886 6.5 1.625 6.27614 1.625 6C1.625 5.72386 1.84886 5.5 2.125 5.5H10.875Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrow;
